import React, {useContext, useEffect, useState} from "react";
import Dashboard from "../../../components/Atoms/Dashboard";
import Sidebar from "../../../components/Atoms/Sidebar";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../assets/Css/Homedashboard.css";
import Header from "../../../components/HOC/Header";
import {Offcanvas} from "react-bootstrap";
import {VendorContext} from "../../../context/VendorContext";

const Home = () => {
    const [showSidebar, setShowSidebar] = useState(false); // Manage sidebar visibility on mobile
    const {VendorAnalytics, analyticsData, orders} = useContext(VendorContext);

    useEffect(() => {
        VendorAnalytics();
    }, []);

    const toggleSidebar = () => setShowSidebar(!showSidebar);

    return (
        <div className="vendor-app d-flex flex-column flex-md-row">
            {/* Sidebar for larger screens */}
            <div className="d-none d-md-block">
                <Sidebar />
            </div>

            {/* Offcanvas sidebar for mobile */}
            <Offcanvas
                show={showSidebar}
                onHide={toggleSidebar}
                className="vendor-mobile-menu"
                style={{width: "288px", backgroundColor: "#1c2939", color: "white"}}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title className="text-white">Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <div style={{height: "100vh"}}>
                    <Sidebar />
                </div>
            </Offcanvas>

            {/* Main content */}
            <main className="vendor-main">
                <Header title={"Dashboard"} toggleSidebar={toggleSidebar} />
                <Dashboard data={analyticsData} order={orders} />
            </main>
        </div>
    );
};

export default Home;
